import type { FC } from "react";

import { BookmarkIconAsButton } from "components";
import { BlacklistIconAsButton } from "features/Blacklist/BlacklistToggleButton";
import { AssignmentHistoryButton } from "components/Buttons/AssignmentHistory";
import { TutoringHistoryAssignmentsNavigation } from "features/AssignmentsNavigation/TutoringHistoryAssignment";

interface Props {
  assignmentId: string;
  userAssignmentId: string;
  tutoringId: string;
  onNavigate: (assignmentId: string) => void;
  title: string;
}

export const TutoringHistoryAssignmentDetailHeader: FC<Props> = ({
  assignmentId,
  tutoringId,
  title,
  userAssignmentId,
  onNavigate,
}) => (
  <div className="assignment-detail-header">
    <div className="assignment-detail-header__title">
      <h2 className="mb-0">{title}</h2>
    </div>
    <div className=" me-4px pe-2">
      <AssignmentHistoryButton userAssignmentId={userAssignmentId} assignmentId={assignmentId} />
    </div>
    <div className="border-start border-1 assignment-navigation px-2">
      <BlacklistIconAsButton className="ms-4px" userAssignmentId={userAssignmentId} />
      <BookmarkIconAsButton className="ms-4px" userAssignmentId={userAssignmentId} />
    </div>
    <div className="border-start border-1 ps-2">
      <TutoringHistoryAssignmentsNavigation
        userAssignmentId={userAssignmentId}
        tutoringId={tutoringId}
        onNavigate={onNavigate}
      />
    </div>
  </div>
);
